import uuidV4 from 'lib/string/uuidV4Utils'

interface Prize {
  key: string
  title: string
  type: 'Grand Prize' | 'Runner up prize'
  image: App.Image
  description: string
}

export const RUNNER_UP_PRIZES = {
  AU: 'A$100 credit to use towards your next escape for 300 lucky winners!*',
  NZ: 'NZ$100 credit to use towards your next escape for 100 lucky winners!*',
  US: 'US$250 credit to use towards your next escape for 50 lucky winners!*',
  GB: '£250 credit to use towards your next escape for 50 lucky winners!*',
}

export const PRIZES: Array<Prize> = [
  {
    key: uuidV4(),
    title: 'Mana Island Resort and Spa',
    type: 'Grand Prize',
    image: { id: '2sbduzt4vger4jcuczz' },
    description: `**5 nights in a Deluxe Ocean View Bure**
- Guaranteed double upgrade from an Island Bure to Deluxe Ocean View Bure
- Two children (14 and under) stay free, sleeping on existing bedding, with all dining inclusions and Kids' Club access
- Daily buffet breakfast at Mamanuca Restaurant
- Daily buffet lunch at Mamanuca Restaurant
- Nightly buffet dinner at Mamanuca Restaurant
- Daily drink at Vonu Bar or the swim-up pool bar
- FJ$300 credit to use on all bars, restaurants and activities
- Complimentary use of non-motorised water equipment
- Complimentary Wi-Fi for up to two devices
- Inclusions valid for two guests
      `,
  },
  {
    key: uuidV4(),
    title: 'Shangri-La Rasa Ria, Kota Kinabalu',
    type: 'Grand Prize',
    image: { id: '3paydqkuxphe1udys8gn' },
    description: `**5 nights in a Garden Wing Deluxe Sea View**
- Guaranteed upgrade from Superior Rainforest Room to Deluxe Seaview Room
- Daily buffet breakfast at Coffee Terrace
- One set-menu three-course lunch at Oceano
- One buffet dinner at Tepi Laut or Coffee Terrace
- Daily beer or glass of wine per adult at Sampan Bar
- One-way private airport transfer
- One 30-minute head and shoulder massage per adult at The Spa
- One sunrise hike per package
- Daily scheduled shuttle bus services from the hotel to Kota Kinabalu City
- Unlimited non-motorised watersports equipment hire
- Unlimited access to Cool Zone Kids Club for two children
- Access to the Discovery Centre, onsite forest garden and waterfall
- Inclusions valid for two guests`,
  },
  {
    key: uuidV4(),
    title: 'Essence Peregian Beach – Boutique Hotel & Holiday Homes',
    type: 'Grand Prize',
    image: { id: 's25km2d43rsor0aehh' },
    description: `**5 nights in a Three-Bedroom House**
- Holiday house welcome hamper of snacks and drinks
- Welcome bottle of wine in house on arrival
- Self-parking for up to two vehicles per package
- Complimentary Wi-Fi
- Inclusions valid for six guests`,
  },
  {
    key: uuidV4(),
    title: 'The Sands Khao Lak by Katathani',
    type: 'Grand Prize',
    image: { id: '0sei2xqm09h4ao6uo57l' },
    description: `**8 nights in the Sands Room**
- Daily breakfast at The Floating Market
- Two three-course set-menu lunches or dinners per person
- Two 60-minute massages per adult at Beachfront Sala Thai Massages
- The Sands Luxury Club access with daily free-flow drinks hour
- One-way private airport transfer on arrival
- Inclusions valid for two guest`,
  },
  {
    key: uuidV4(),
    title: 'Hawaii: Pride of America Island Hopping Cruise with Waikiki Outrigger Stays & Bonus Premium Drinks',
    type: 'Grand Prize',
    image: { id: 'nruhp3lclj7ry2iad0yg' },
    description: `**10 nights in a Twin Room - Inside Stateroom**
- Packages valid for one person (twin room) – you MUST purchase TWO packages
- Seven nights cruising onboard Norwegian Cruise Line’s Pride of America in an Inside Stateroom
- Two nights of pre-cruise accommodation and one night of post-cruise accommodation in an Ocean View Room at OUTRIGGER Waikiki Beach Resort, with breakfast
- All-inclusive dining, with daily breakfast, lunch and dinner in select restaurants onboard
- One Specialty Dining meal at select onboard bars, restaurants and eateries
- Premium Drinks package, including spirits, cocktails, beer and wine onboard (valued up to A$1,167)
- US$50 shore excursion credit per stateroom in each port (valued up to US$200)
- 300 minutes of Wi-Fi per cabin across two devices
- All port taxes, service charges, gratuities and onboard entertainment
`,
  },
  {
    key: uuidV4(),
    title: 'The Apurva Kempinski Bali',
    type: 'Grand Prize',
    image: { id: 'hdifik3u5frxij87k9d' },
    description: `**5 nights in a Cliff Private pool Junior Suite**
- Daily breakfast at Cliff Lounge or Pala Restaurant
- Daily choice of lunch or dinner at Reef Beach Club, Bai Yun, Izakaya by Oku or Pala Restaurant
- Daily access to the Cliff Lounge with refreshments
- Nightly free-flow drinks hour with canapes at Pala Restaurant or Cliff Lounge
- One 50-minute massage treatment at Apurva Spa per adult
- Signature welcome drink per person
- VIP check-in and checkout and dedicated concierge service for Suite and Villa guests
- Daily Kids’ Club access at Jalak Family Club
- Daily resort activities based on resort schedule
- Inclusions valid for two guests`,
  },
]
